import { Component, Input } from '@angular/core';
import { ViewBreakpointService } from '@common-module/app-services/view-breakpoint.service';
import { UnitAdditionalData } from '@common-module/modelinterfaces/unit-additional-data.model';
import { NgClass, AsyncPipe } from '@angular/common';
import {LocalDate} from '@js-joda/core';
import {LocalDateUtil} from '@common-module/utils/date-time/local-date.util';
import {LocalDateFormatPipe} from '@common-module/pipes/local-date-format.pipe';
import { ExpireIconComponent } from '../../../../../shared/components/expire-icon/expire-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-expire-info-card',
    templateUrl: './expire-info-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [NgClass, ExpireIconComponent, AsyncPipe, LocalDateFormatPipe, TranslateModule]
})

export class ExpireInfoCardComponent {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;


  constructor(public viewBreakpointService: ViewBreakpointService) {
  }

  // UnitDataService обновляет vehicle без замены unitData: ngOnChanges здесь недостаточно.
  protected get inspectionDate(): LocalDate | null {
    return this.parseDate(this.unitData?.vehicle?.expiryDateTechInspection);
  }

  protected get insuranceDate(): LocalDate | null {
    return this.parseDate(this.unitData?.vehicle?.expiryDateInsurance);
  }

  protected get speedometerDate(): LocalDate | null {
    return this.parseDate(this.unitData?.vehicle?.expiryDateSpeedometer);
  }

  private parseDate(value: string | null | undefined): LocalDate | null {
    // Сроки транспорта — календарные даты API, не UTC-моменты.
    return value ? LocalDateUtil.fromFormattedString(value, 'yyyy-MM-dd') : null;
  }
}
